var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFullBathRemodel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "full-bath-remodel",
    viewBox: "0 0 188.5 161.5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.8 81.5h-7.6c-0.8 0-1.3 0.2-1.5 0.2l5.9 26.5h0.8 3.6c-3.1-3.8-5.2-7.7-5.2-13.4-0.1-4.9 1.3-9.5 4-13.3z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m45.5 108.2 5.7-26.5c-0.2 0-0.5-0.2-1.5-0.2h-7.5c2.5 3.6 3.9 8.2 3.9 13.3 0 5.7-2.1 9.8-5.1 13.4h4 0.5z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m37.5 108.2c3.6-3.9 6.1-7.7 6.1-13.4 0-5.2-1.8-9.8-4.7-13.3-1-1.1-2.3-2.3-3.4-2.9-2.3-1.3-4.6-2.1-7.2-2.1s-5.1 0.8-7.2 2.1c-1.1 0.8-2.3 1.8-3.4 2.9-2.9 3.4-4.7 8-4.7 13.3 0 5.7 2.3 9.3 6.1 13.4h18.4z",
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m165 112.4c-2.3 0.7-4.9 1-7.5 1-2.3 0-4.6-0.3-6.9-0.8l-5.7 44.7c0 0.7 0.7 1.1 1.5 1.1h23.1c0.8 0 1.3-0.7 1.3-1.3l-5.8-44.7v0z",
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m185.9 86.4h-11.8v-5.9h1.6c0.8 0 1.3-0.7 1.3-1.3v-0.2c0-0.8-0.7-1.3-1.3-1.3h-6.3c-0.8 0-1.3 0.7-1.3 1.3v0.2c0 0.8 0.7 1.3 1.3 1.3h1.6v5.9h-7.9l-1.6-8c-0.3-1.6-0.7-3.6-2.5-3.6v-4.8c0-0.8-0.7-1.5-1.5-1.5s-1.5 0.7-1.5 1.5v4.7c-1.8 0-2.6 1.5-3.1 3.6l-1.6 8h-9.8v-5.9h1.6c0.8 0 1.3-0.7 1.3-1.3v-0.1c0-0.8-0.7-1.3-1.3-1.3h-6c-0.8 0-1.3 0.7-1.3 1.3v0.2c0 0.8 0.7 1.3 1.3 1.3h1.5v5.9h-8.9c-0.8 0-1.5 0.7-1.5 1.5s0.7 1.5 1.5 1.5h4.1c0.5 8.5 6.7 15.9 15.4 18.8 2.5 0.8 5.4 1.3 8.3 1.3 3.1 0 6.1-0.7 8.7-1.5 8.5-2.9 14.6-10.1 14.9-18.7h5c0.8 0 1.5-0.7 1.5-1.5-0.1-0.7-0.9-1.4-1.7-1.4z",
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m28.2 134c-3.4 0-6.7-0.7-9.7-1.6l-3.6 24.5c0 0.5 0.8 1.6 1.3 1.6h22.9c0.7 0 1.3-1 1.3-1.8l-3.6-24.1c-2.6 0.9-5.5 1.4-8.6 1.4z",
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m53.5 114.1h2.1c0.8 0 1.5-0.7 1.5-1.5s-0.7-1.5-1.5-1.5h-44.3-0.3-8.7c-0.8 0-1.1 0.5-1.3 1.1v0.3c0 0.3 0.2 0.5 0.3 0.8 0 0.5 0.5 0.8 1 0.8h1.9c1.3 6.1 5.7 11.1 11.8 14.1 0.5 0.3 1 0.5 1.5 0.8 0.5 0.2 0.8 0.3 1.3 0.5 2.8 1 5.9 1.6 9.2 1.6 2.9 0 5.9-0.5 8.5-1.3 0.5-0.2 0.8-0.3 1.3-0.5 0.7-0.2 1-0.5 1.5-0.7 6.4-2.9 11.1-8.2 12.4-14.6 0 0.1 1.8 0.1 1.8 0.1z",
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m135.5 7.4v43.1c0 4.1 3.3 7.4 7.4 7.4h29.6c4.1 0 7.4-3.3 7.4-7.4v-43.1c0-4.1-3.3-7.4-7.4-7.4h-29.5c-4.2 0-7.5 3.3-7.5 7.4zm37.1-4.5c2.5 0 4.4 2 4.4 4.4v43.1c0 2.5-2 4.4-4.4 4.4h-29.6c-2.5 0-4.4-2-4.4-4.4v-43c0-2.5 2-4.4 4.4-4.4h29.6z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m88.6 26.1 10.3 10.3c1.3-1.3 4.1-5.6 4.6-7l-7.9-7.9c-1.1 0.4-5.7 3.3-7 4.6z",
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m87 34.5c0.2 0 0.5 0 0.7-0.3l1-1c0.2-0.2 0.2-0.2 0.2-0.3 0.2-0.3 0.2-0.7-0.2-0.8-0.3-0.3-0.7-0.3-0.8-0.2-0.2 0-0.2 0-0.3 0.2l-1 1c-0.3 0.3-0.3 0.8 0 1 0.1 0.4 0.3 0.4 0.4 0.4z",
    fill: "currentColor"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m83.8 37.8c0.2 0 0.5 0 0.7-0.3l1-1c0.3-0.3 0.3-0.8 0-1-0.3-0.3-0.8-0.3-1 0l-1 1c-0.3 0.3-0.3 0.8 0 1-0.1 0.3 0.1 0.3 0.3 0.3z",
    fill: "currentColor"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m82.1 38.6c-0.3-0.3-0.8-0.3-1 0l-1.1 1.1c-0.3 0.3-0.3 0.8 0 1 0.2 0.2 0.3 0.3 0.7 0.3 0.3 0 0.5 0 0.7-0.3l1-1c0.1-0.1 0.1-0.8-0.3-1.1z",
    fill: "currentColor"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m88.7 36.5c0.2 0.2 0.3 0.3 0.7 0.3 0.3 0 0.5 0 0.7-0.3l1-1s0-0.2 0.2-0.3c0.2-0.3 0.2-0.7-0.2-0.8-0.3-0.3-0.7-0.3-0.8-0.2-0.2 0-0.2 0-0.3 0.2l-1.1 1c-0.5 0.2-0.5 0.9-0.2 1.1z",
    fill: "currentColor"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m86.6 37.6-1.1 1c-0.3 0.3-0.3 0.8 0 1 0.2 0.2 0.3 0.3 0.7 0.3 0.3 0 0.5 0 0.7-0.3l1-1c0.3-0.3 0.3-0.8 0-1-0.5-0.3-1.2-0.3-1.3 0z",
    fill: "currentColor"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m84.3 40.9c-0.3-0.3-0.8-0.3-1 0l-1.1 1c-0.3 0.3-0.3 0.8 0 1 0.2 0.2 0.3 0.3 0.7 0.3 0.3 0 0.5 0 0.7-0.3l1-1c0-0.4 0-0.9-0.3-1z",
    fill: "currentColor"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m92.3 36.5c-0.2 0-0.2 0-0.3 0.2l-1 1c-0.3 0.3-0.3 0.8 0 1 0.2 0.2 0.3 0.3 0.7 0.3 0.3 0 0.5 0 0.7-0.3l1-1c0.2-0.2 0.2-0.2 0.2-0.3 0.2-0.3 0.2-0.7-0.2-0.8-0.5-0.3-0.8-0.3-1.1-0.1z",
    fill: "currentColor"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m88.7 39.7-1 1.1c-0.3 0.3-0.3 0.8 0 1 0.2 0.2 0.3 0.3 0.7 0.3 0.3 0 0.5 0 0.7-0.3l1-1c0.3-0.3 0.3-0.8 0-1-0.6-0.2-1.1-0.2-1.4-0.1z",
    fill: "currentColor"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m85.4 43-1 1.1c-0.3 0.3-0.3 0.8 0 1 0.2 0.2 0.3 0.3 0.7 0.3 0.3 0 0.5 0 0.7-0.3l1-1c0.3-0.3 0.3-0.8 0-1-0.6-0.4-1.1-0.4-1.4-0.1z",
    fill: "currentColor"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M123.7,158.4V0H61.5v158.4H123.7z M64.5,2.9h56.3v152.3h-2.9V17.6c0-0.8-0.7-1.5-1.5-1.5h-7.2    c-0.5,0-0.8,0.2-1,0.5l-4.6,4.3c-1.5-1-3.4-0.5-4.6,0l5.4,5.4c0.3-0.8,0.5-1.6,0.7-2.3l4.9-4.6h5.2v136.1H64.5V2.9z",
    fill: "currentColor"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m74.1 75.4h-1.5c-2.8 0-5.2 2.3-5.2 5.2v13.3c0 2.8 2.3 5.2 5.2 5.2h1.5c2.8 0 5.2-2.3 5.2-5.2v-13.5c0.1-2.7-2.4-5-5.2-5zm2.3 18.5c0 1.1-1 2.3-2.3 2.3h-1.5c-1.1 0-2.3-1-2.3-2.3v-13.5c0-1.1 1-2.3 2.3-2.3h1.5c1.1 0 2.3 1 2.3 2.3v13.5z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.3,
    y: 54,
    width: 44.9,
    height: 7.9,
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 1.7819
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.3,
    y: 19.8,
    width: 44.9,
    height: 7.9,
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 1.7819
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullBathRemodel);
export default __webpack_public_path__ + "static/media/full-bath-remodel.a29c5b2744de1739c7ffb1f46bdc990d.svg";
export { ForwardRef as ReactComponent };